const binding = { modules: {}, dataActions: {} };

    (binding.modules['britax-cookie-compliance'] = {
        c: () => require('partner/modules/britax-cookie-compliance/britax-cookie-compliance.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'britax-cookie-compliance',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/britax-cookie-compliance'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|britax-cookie-compliance|britax-cookie-compliance'] = {
                c: () => require('partner/modules/britax-cookie-compliance/britax-cookie-compliance.view.tsx'),
                cn: '__local__-__local__-britax-cookie-compliance'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };